import styled from 'styled-components'

import { Color } from 'constants/color'

export const Wrapper = styled.div`
    background: ${Color.transparentBlack};
    width: auto;
    height: 38px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 16px;
`

export const SliderContainer = styled.div`
    display: flex;
    flex: 1;
    margin-left: 16px;
    margin-right: 16px;
`

export const ControlImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-left: 8px;
    margin-right: 8px;
    cursor: pointer;
`

export const ControlImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    filter: brightness(0) invert(1);
`
